import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import s from './Product.module.scss'

// 产品配置数据
const PRODUCTS_CONFIG = [
  {
    id: 'goose3t',
    to: '/temp-rh-monitor-3t/overview',
    className: s.goose,
    titleId: 'goose3t',
    isNew: true,
    features: [
      { text: 'gs3t_first_desc_2' },
      { text: 'goose_screen', separator: '·' },
      { text: 'goose_support_3', breakBefore: true }
    ]
  },
  {
    id: 'goose3duck3',
    to: '/temp-rh-monitor-3/overview',
    className: s.duck3,
    titleId: 'gd3_title',
    isNew: true,
    descStyle: { paddingRight: 0 },
    features: [
      { text: 'goose_support_3' },
      { text: 'duck2_support', separator: '·' },
      { text: 'user', breakBefore: true }
    ]
  },
  {
    id: 'magpie',
    to: '/lee-guitars-thermo-hygrometer/overview',
    className: s.magpie,
    titleId: 'magpie',
    titleValues: { br: '' },
    descStyle: { paddingRight: 35 },
    features: [
      { text: 'grasp_guitar_sip' },
      { text: 'e_link', separator: '·' },
      { text: 'record_history_data', breakBefore: true }
    ]
  },
  {
    id: 'hodor',
    to: '/door-window-sensor/overview',
    className: s.hodor,
    titleId: 'hodor',
    features: [
      { text: 'hodor_monitor' },
      { text: 'automation', breakBefore: true },
      { text: 'p_wifi_value', separator: '·' }
    ]
  },
  {
    id: 'parrot',
    to: '/motion-light-sensor/overview',
    className: s.parrot,
    titleId: 'parrot_title',
    features: [
      { text: 'parrot_des1' },
      { text: 'parrot_des2', breakBefore: true }
    ]
  },
  {
    id: 'dove',
    to: '/bluetooth-alarm-clock/overview',
    className: s.dove,
    titleId: 'dove',
    features: [
      { text: 'button_less' },
      { text: 'temp_rh_mon', separator: '·' },
      { text: 'soft_backlight', breakBefore: true },
      { text: 'sixteen_ala', separator: '·' }
    ]
  },
  {
    id: 'sparrow',
    to: '/bluetooth-gateway/overview',
    className: s.sparrow,
    titleId: 'sparrow',
    features: [
      { text: 'connect_mi' },
      { text: 'enable_remote', separator: '·' },
      { text: 'automation', separator: '·' }
    ]
  },
  {
    id: 'pheasant',
    to: '/temp-rh-monitor-pro-s/overview',
    className: s.lora,
    titleId: 'pheasant_s',
    titleValues: { br: '' },
    descStyle: { paddingRight: 0 },
    features: [
      { text: 'l_support' },
      { text: 'l_battery', breakBefore: true },
      { text: 'l_user', separator: '·' }
    ]
  },
  {
    id: 'frogs',
    to: '/multi-role-monitor/overview',
    className: s.frogs,
    titleId: 'frogs',
    titleValues: { br: '' },
    isNew: true,
    descStyle: { paddingRight: 0 },
    features: [
      { text: 'frogs_support_1' },
      { text: 'frogs_support_2', separator: '·' },
      { text: 'frog_support_4', breakBefore: true }
    ]
  },
  {
    id: 'pheasant_co2',
    to: '/co2-temp-rh-monitor/overview',
    className: s.pheasant_co2,
    titleId: 'pheasant_co2_title',
    features: [
      { text: 'pheasant_co2_des1' },
      { text: 'pheasant_co2_des2', breakBefore: true }
    ]
  },
  {
    id: 'robb',
    to: '/indoor-environment-monitor/overview',
    className: s.robb,
    titleId: 'robb',
    isNew: true,
    features: [
      { text: 'robb_product_desc1', values: { br: <br /> } },
      { text: 'robb_product_desc2', breakBefore: true }
    ]
  },
  {
    id: 'snow2',
    to: '/air-monitor-2/overview',
    className: s.snow,
    titleId: 'snow2',
    titleClassName: s.title_snow2,
    customRender: true
  },
  {
    id: 'dany',
    to: '/air-monitor-lite/overview',
    className: s.dany,
    titleId: 'dany',
    titleClassName: s.title_dany,
    descClassName: s.desc_dany,
    customRender: true
  }
]

// 服务/平台配置
const SERVICES_CONFIG = [
  {
    id: 'cgapp',
    to: '/home-app',
    className: s.app,
    titleId: 'cg_app',
    features: [
      { text: 'device_management' },
      { text: 'data_insights', separator: '·' },
      { text: 'historical_data', breakBefore: true },
      { text: 'access_remote', separator: '·' }
    ]
  },
  {
    id: 'iot',
    href: 'https://qingpingiot.com',
    className: s.qingpingiot,
    titleId: 'qing_ping_iot',
    features: [
      { text: 'team_management' },
      { text: 'data_collection', separator: '·' },
      { text: 'device_sharing', breakBefore: true },
      { text: 'alarm_notification', separator: '·' }
    ]
  },
  {
    id: 'developer',
    href: 'https://developer.qingping.co',
    className: s.developer,
    titleId: 'index_developer',
    features: [
      { text: 'customize_device' },
      { text: 'own_platform', separator: '·' }
    ]
  }
]

// 产品列表项组件
const ProductItem = ({ product, onClickLink, locale }) => {
  const {
    className,
    to,
    titleId,
    titleValues,
    titleClassName,
    descClassName,
    descStyle,
    isNew,
    features
  } = product

  // snow2 产品的自定义渲染
  if (product.id === 'snow2') {
    const isEnglish = locale.indexOf('US') > -1
    return (
      <li className={className}>
        <Link to={to} onClick={onClickLink}>
          <div className={titleClassName || s.title}>
            <FormattedMessage id={titleId} />
          </div>
          <div className={s.desc}>
            <FormattedMessage id="pm25" />
            <span className={s.line}>·</span>
            <FormattedMessage id="pm10" />
            <span className={s.line}>·</span>
            <FormattedMessage id="noise" />
            <span className={s.line}>·</span>
            <FormattedMessage id="co2" />
            {isEnglish ? <span className={s.line}>·</span> : <br />}
            <FormattedMessage id="etvoc" />
            <span className={s.line}>·</span>
            <FormattedMessage id="temperature" />
            <span className={s.line}>·</span>
            <FormattedMessage id="hum" />
            <br />
            <FormattedMessage id="snow2_sensor" />
            <span className={s.line}>·</span>
            <FormattedMessage id="snow_screen" />
          </div>
        </Link>
      </li>
    )
  }

  // dany 产品的自定义渲染
  if (product.id === 'dany') {
    return (
      <li className={className}>
        <Link to={to} onClick={onClickLink}>
          <div className={titleClassName || s.title}>
            <FormattedMessage id={titleId} />
          </div>
          <div className={descClassName || s.desc}>
            <FormattedMessage id="pm25" />
            <span className={s.line}>·</span>
            <FormattedMessage id="pm10" />
            <span className={s.line}>·</span>
            <FormattedMessage id="co2" />
            <span className={s.line}>·</span>
            <FormattedMessage id="temperature" />
            <span className={s.line}>·</span>
            <FormattedMessage id="hum" />
            <br />
            <FormattedMessage id="touchbar" />
            <span className={s.line}>·</span>
            <FormattedMessage id="support_all_pc" values={{ br: <br /> }} />
          </div>
        </Link>
      </li>
    )
  }

  // 常规产品渲染
  return (
    <li className={className}>
      <Link to={to} onClick={onClickLink}>
        <div className={titleClassName || s.title}>
          <FormattedMessage id={titleId} values={titleValues} />
          {isNew && (
            <div className={s.new_tag}>
              <FormattedMessage id="new_tag" />
            </div>
          )}
        </div>
        <div className={descClassName || s.desc} style={descStyle}>
          {features.map((feature, index) => (
            <React.Fragment key={index}>
              {feature.breakBefore && <br />}
              {feature.separator && <span className={s.line}>{feature.separator}</span>}
              <FormattedMessage id={feature.text} values={feature.values} />
            </React.Fragment>
          ))}
        </div>
      </Link>
    </li>
  )
}

// 服务/平台项组件
const ServiceItem = ({ service, onClickLink }) => {
  const { className, href, to, titleId, features } = service

  const content = (
    <>
      <div className={s.title}>
        <FormattedMessage id={titleId} />
      </div>
      <div className={s.desc}>
        {features.map((feature, index) => (
          <React.Fragment key={index}>
            {feature.breakBefore && <br />}
            {feature.separator && <span className={s.line}>{feature.separator}</span>}
            <FormattedMessage id={feature.text} />
          </React.Fragment>
        ))}
      </div>
    </>
  )

  return (
    <li className={className}>
      {href ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      ) : (
        <Link to={to} onClick={onClickLink}>
          {content}
        </Link>
      )}
    </li>
  )
}

const Product = ({ locale }) => {
  const toTop = useCallback(() => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }, [])

  const isEnglish = locale.indexOf('US') > -1

  return (
    <div className={s.product}>
      <div>
        <ul className={isEnglish ? s.ul_en : s.ul_cn}>
          {PRODUCTS_CONFIG.map((product) => (
            <ProductItem
              key={product.id}
              product={product}
              onClickLink={toTop}
              locale={locale}
            />
          ))}
          {SERVICES_CONFIG.map((service) => (
            <ServiceItem
              key={service.id}
              service={service}
              onClickLink={toTop}
            />
          ))}
        </ul>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  locale: state.language,
})

export default connect(mapStateToProps)(Product)
